import { getStandardMode } from 'libs/ui/Button/mode/standard';
import { CSSObject } from 'libs/ui/styled';
import { Colors, Theme } from 'libs/ui/theme';

import { ButtonColorVariant, ButtonSize } from '../types';

const getColorPrimary = () => ({
  textColor: Colors.black,

  hoverTextColor: Colors.hover,

  focusTextColor: Colors.black,

  disableTextColor: Colors.gray300,
});

const getColorRed = () => ({
  textColor: Colors.black,

  hoverTextColor: Colors.gray300,

  focusTextColor: Colors.black,

  disableTextColor: Colors.gray300,
});

export const getTextMode = (
  theme: Theme,
  colorVariant: ButtonColorVariant,
  size: ButtonSize = 'l'
): CSSObject => {
  const colors = colorVariant === 'primary' ? getColorPrimary() : getColorRed();
  return {
    ...getStandardMode(theme, colorVariant, size),
    paddingLeft: '8px',
    paddingRight: '8px',
    color: colors.textColor,
    backgroundColor: 'transparent',

    '&:hover': {
      background: 'none',
      color: colors.hoverTextColor,
    } as CSSObject,

    '&:active': {
      background: 'none',
      color: colors.focusTextColor,
    } as CSSObject,

    '&:disabled': {
      background: 'none',
      color: colors.disableTextColor,
    } as CSSObject,
  };
};
